import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import reducer from "./../reducers/index";
import sessionManager from "../utils/simpleSessionManager";

// Custom storage adapter implementing the reversed session management flow
const reversedSessionStorage = {
  getItem: (key) => {
    try {
      const sessionType = sessionManager.getSessionType();
      
      if (sessionType === 'impersonation') {
        // For impersonation: read from localStorage only
        return Promise.resolve(window.localStorage.getItem(key));
      } else if (sessionType === 'normal') {
        // For normal login: prefer sessionStorage, fallback to localStorage
        const sessionData = window.sessionStorage.getItem(key);
        if (sessionData) {
          return Promise.resolve(sessionData);
        }
        return Promise.resolve(window.localStorage.getItem(key));
      } else {
        // No active session: try localStorage as fallback
        return Promise.resolve(window.localStorage.getItem(key));
      }
    } catch (e) {
      return Promise.resolve(null);
    }
  },
  
  setItem: (key, value) => {
    try {
      const sessionType = sessionManager.getSessionType();
      
      if (sessionType === 'impersonation') {
        // For impersonation: store in localStorage only
        window.localStorage.setItem(key, value);
        return Promise.resolve(true);
      } else if (sessionType === 'normal') {
        // For normal login: store in both sessionStorage and localStorage
        window.sessionStorage.setItem(key, value);
        window.localStorage.setItem(key, value);
        return Promise.resolve(true);
      } else {
        // Default: store in localStorage
        window.localStorage.setItem(key, value);
        return Promise.resolve(true);
      }
    } catch (e) {
      return Promise.resolve(false);
    }
  },
  
  removeItem: (key) => {
    try {
      const sessionType = sessionManager.getSessionType();
      
      if (sessionType === 'impersonation') {
        // For impersonation: remove from localStorage only
        window.localStorage.removeItem(key);
        return Promise.resolve(true);
      } else {
        // For normal login or default: remove from both storages
        window.sessionStorage.removeItem(key);
        window.localStorage.removeItem(key);
        return Promise.resolve(true);
      }
    } catch (e) {
      return Promise.resolve(false);
    }
  },
};

const persistConfig = {
  key: "reducer",
  storage: reversedSessionStorage,
  whitelist: ["loginReducer", "headerMenuReducer", "manageInventoryReducer"],
};

const persistedReducer = persistReducer(persistConfig, reducer);
const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk))
);
const persistedStore = persistStore(store);

// Export session manager along with store for convenience
export { persistedStore, store, sessionManager };
